// @flow

import React from 'react';
import moment from 'moment';

import t from '../../utils/translate';
import { IN_PROGRESS } from '../../constants/challengeStatusTypes';
import { isInProgress, isMatchComplete } from '../../utils/challengeUtils';

type Props = {
  lang?: string,
  matchType?: string,
  statusId: number,
  startTime?: string,
  progress?: string
};

const defaultProps = {
  lang: 'en',
  matchType: 'Match',
  startTime: undefined,
  progress: undefined
};

const MatchTime = ({ lang, statusId, startTime, progress, matchType }: Props) => {
  if (isMatchComplete(statusId)) {
    return <span>{t(`${matchType.toUpperCase()} complete`)}</span>;
  }

  if (isInProgress(statusId)) {
    return (
      <span>
        {t('Live')}
        {progress && <span> - {progress}</span>}
      </span>
    );
  }

  if (startTime) {
    return (
      <span>
        {moment(startTime)
          .locale(lang)
          .format('ddd, DD MMM YYYY - h:mm a')}
      </span>
    );
  }

  return <span>{t('Yet to start')}</span>;
};

MatchTime.defaultProps = defaultProps;

export default MatchTime;
